export default __webpack_public_path__ + "static/0079-d2dbae0f3eb2e2a324518bd49e5b8ab7.png";